import React from 'react'
import { StaticImage } from 'gatsby-plugin-image'
export default function Country() {
  return (
    <div>
      <StaticImage  alt='' src='../../images/country.png'/>
      <div className="flex justify-center pt-[60px] pb-[85px] pl-[20px] pr-[20px]">
        <p className='max-w-[640px] text-center text-[13px] leading-[18px]'>
        James St acknowledges the Traditional Owners and Custodians of the Country on which we live, learn and work. We pay our respects to the Turrbal and Jagera people and all Aboriginal and Torres Strait Islander Elders past, present and emerging.
        </p>
      </div>
    </div>
  )
}
